/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Edit({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9.604 2.878a2.6 2.6 0 0 1 3.677 0l.354.354a2.6 2.6 0 0 1 0 3.677L7.232 13.31a2.6 2.6 0 0 1-1.343.714l-3.348.65a.6.6 0 0 1-.703-.704l.65-3.347A2.6 2.6 0 0 1 3.2 9.281l6.403-6.403Zm2.829.849a1.4 1.4 0 0 0-1.98 0l-5.94 5.94L6.846 12l5.94-5.94a1.4 1.4 0 0 0 0-1.98l-.353-.353ZM5.92 12.77l-2.177-2.177a1.4 1.4 0 0 0-.077.26l-.48 2.474 2.474-.48c.09-.017.176-.043.26-.077Z" clipRule="evenodd" /></svg>;
}
;